import { Button } from "@a2z/ui-v2";

import { useNavigate } from "react-router-dom";
import { useNavigationGuard } from "@/lib/navigation/navigationGuard";

type BackButtonProps = {
  label: string;
  fallbackHref?: string;
};

export function BackButton({ label, fallbackHref }: BackButtonProps) {
  const navigate = useNavigate();
  const guard = useNavigationGuard();

  const navigateBack = () => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      navigate(-1);
      return;
    }
    if (fallbackHref) {
      navigate(fallbackHref);
    }
  };

  return (
    <Button variant="ghost"
      type="button"
      onClick={() => {
        if (guard?.isDirty) {
          guard.promptDiscard(() => navigateBack(), { allowHistoryPop: true });
          return;
        }
        navigateBack();
      }}
      className="w-fit text-body font-semibold text-muted"
    >
      {label}
    </Button>
  );
}
